import src from "IMAGE";
export default { src, width: 388, height: 151, blurWidth: 0, blurHeight: 0};
